import { render, staticRenderFns } from "./VerificationDetail.vue?vue&type=template&id=1d084d7e&"
import script from "./VerificationDetail.vue?vue&type=script&lang=js&"
export * from "./VerificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetail.vue?vue&type=style&index=0&id=1d084d7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports